import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { openFormModal, setSearch } from "../../store/reducers/talentos/talentos.reducer";
import SearchInput from "../UI/SearchInput";

const TalentosHeader = () => {
  const dispatch = useDispatch();
  const searchValue = useSelector((state) => state.talentos.search);

  const handleSearchChange = (value) => {
    dispatch(setSearch(value));
  };

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        {/* título */}
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Gestión de talentos
          </h5>
        </div>

        {/* buscador + botón */}
        <div className="col-12 col-md">
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
            <SearchInput
              value={searchValue}
              onChange={handleSearchChange}
              placeholder="Buscar por nombre..."
              minChars={3}
              className="flex-grow-1"
            />

            {/* botón */}
            <button
              onClick={() => dispatch(openFormModal({ mode: "create" }))}
              className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8"
              style={{ height: "44px", minWidth: "140px" }}
            >
              <Icon icon="mdi:plus" width="20" />
              <span className="d-none d-sm-inline fw-medium">Agregar talento</span>
              <span className="d-inline d-sm-none fw-medium">Nuevo</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentosHeader;
